export default "__VITE_ASSET__DbWrSnQl__"